import { render, staticRenderFns } from "./cardFamiliaProducto.vue?vue&type=template&id=2995731e&scoped=true&"
import script from "./cardFamiliaProducto.vue?vue&type=script&lang=js&"
export * from "./cardFamiliaProducto.vue?vue&type=script&lang=js&"
import style0 from "./cardFamiliaProducto.vue?vue&type=style&index=0&id=2995731e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995731e",
  null
  
)

export default component.exports